import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LoadingService {
    private isLoadingSubject = new BehaviorSubject<boolean>(true);
    isLoading$ = this.isLoadingSubject.asObservable();

    setLoading(loading: boolean) {
        this.isLoadingSubject.next(loading);
    }
} 